import { render, staticRenderFns } from "./DataToDB.vue?vue&type=template&id=22b24280"
import script from "./DataToDB.vue?vue&type=script&lang=js"
export * from "./DataToDB.vue?vue&type=script&lang=js"
import style0 from "./DataToDB.vue?vue&type=style&index=0&id=22b24280&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports